// extracted by mini-css-extract-plugin
export default {"button":"FeedbackStepInfo_button__8lr7V","info":"FeedbackStepInfo_info__M9ima"};